module.exports = __webpack_public_path__ + "img/user25.fa8164b0.jpg";